import { ReactComponent as PresentSVG } from "./present.svg";
import { SvgIcon } from '@mui/material';

export default function IconPresent(props) {
  return <SvgIcon {...props} component={PresentSVG} viewBox="0 0 20 21" />;
}